import * as ActionTypes from './actionTypes.js';
import _ from 'lodash';
import { TYPE_OWNER, TYPE_REVIEWER } from "./constants.js";

export default function incomingBusinessSummaryReducer(state = {}, action) {
    switch (action.type) {
        case ActionTypes.APPLICATION_SUMMARY_LIST:
            let payloadReceived = action.payload;
            let currentBatchSummary = action.payload.applicationSummary.current;
            let paginatedDetails = currentBatchSummary.metadata.pages.pageNumber === 1 ? [] : state.applicationSummary.paginatedDetails;

            if (currentBatchSummary.metadata.pages.pageNumber * currentBatchSummary.metadata.pages.pageSize > paginatedDetails.length) {
                paginatedDetails = paginatedDetails.concat(currentBatchSummary.data);
            }
            payloadReceived.applicationSummary.paginatedDetails = paginatedDetails;
            return Object.assign({}, state, action.payload, { showErrors: false });

        case ActionTypes.APPLICATION_SUMMARY_LIST_FETCH_FAILED:
        case ActionTypes.APPLICATION_SUMMARY_FILTERS_SEARCH_FAILED:
        case ActionTypes.APPLICATIONS_PDF_FETCH_FAILED:
        case ActionTypes.APPLICATIONS_SUMMARY_SEARCH_FAILED:
        case ActionTypes.APPLICATION_STATEMENT_FETCH_FAILED:
        case ActionTypes.APPLICATION_SUMMARY_FILTERS_LIST_FETCH_FAILED:
            return Object.assign({}, state, action.payload, { showErrors: true });
        case ActionTypes.SET_APPLICATIONS_SUMMARY_LOADING:
        case ActionTypes.APPLICATION_SUMMARY_FILTERS_LIST:
        case ActionTypes.APPLICATION_SUMMARY_FILTERS_LIST_LOADING:
        case ActionTypes.APPLICATION_SUMMARY_FILTERS_SEARCH:
        case ActionTypes.SHOW_PAGINATION_PROGRESS:
        case ActionTypes.DELEGATE_LIST_FETCH:
        case ActionTypes.SET_DELEGATE_LIST_LOADING:
        case ActionTypes.APPLICATIONS_SUMMARY_SEARCH:
        case ActionTypes.APPLICATIONS_PDF_FETCH_SUCCESS:
            return Object.assign({}, state, action.payload, { showErrors: false });
        // Updating the acl of the transferred record.
        case ActionTypes.TRANSFER_SUCCESS:
            if (state.applicationSummary !== undefined) {
                let applicationSummary = state.applicationSummary;
                let data = state.applicationSummary.paginatedDetails;
                let indexOfUpdatedObj = _.findIndex(data, (row) => row.acn === action.payload.acn);

                if (indexOfUpdatedObj !== -1) {
                    let reviewer;
                    let transferPayLoad = action.payload.transferDetailsObj;
                    let actionPerformed = action.payload.actionPerformed;
                    let item = data[indexOfUpdatedObj];
                    item.acl.forEach((aclObj) => {
                        if (aclObj.accessType === TYPE_OWNER) {
                            aclObj.accessType = TYPE_REVIEWER;
                        } else if (aclObj.accessType === TYPE_REVIEWER && aclObj.userId === transferPayLoad.targetId) {
                            reviewer = aclObj;
                            reviewer.accessType = TYPE_OWNER;
                        }
                    });
                    if (!reviewer) {
                        item.acl.push({
                            userId: transferPayLoad.targetId,
                            userRole: transferPayLoad.targetRole,
                            accessType: TYPE_OWNER
                        })
                    }
                    // if(actionPerformed === ACTION_TRANSFER || action.payload.actionPerformed === ACTION_TRANSFER_TO_PRIMARY){
                    //     item.acl.forEach((aclObj) => { 
                    //         if(aclObj.accessType === TYPE_OWNER) { 
                    //             aclObj.accessType = TYPE_REVIEWER;
                    //         }else if(aclObj.accessType === TYPE_REVIEWER && aclObj.userId === transferPayLoad.targetId) { 
                    //             reviewer = aclObj;
                    //             reviewer.accessType = TYPE_OWNER;
                    //         }
                    //     });                    
                    //     if(!reviewer){
                    //         item.acl.push({
                    //             userId: transferPayLoad.targetId,
                    //             userRole: transferPayLoad.targetRole,
                    //             accessType: TYPE_OWNER
                    //         })
                    //     }
                    // }else if(actionPerformed === ACTION_RECALL){
                    //     item.acl.forEach((aclObj)=>{
                    //         if(aclObj.accessType === TYPE_REVIEWER && aclObj.userId === transferPayLoad.targetId) {
                    //             aclObj.accessType = TYPE_OWNER;
                    //         }else if(aclObj.accessType === TYPE_OWNER){
                    //             reviewer = aclObj;
                    //             aclObj.accessType = TYPE_REVIEWER;
                    //         }
                    //     });
                    //     if(!reviewer){
                    //         item.acl.push({
                    //             userId: transferPayLoad.targetId,
                    //             userRole: ROLE_ASSISTANT,
                    //             accessType: TYPE_OWNER
                    //         })
                    //     }

                    // }
                    //    }
                }
                applicationSummary.paginatedDetails = data;
                return Object.assign({}, state, { "applicationSummary": applicationSummary });
            }
        case ActionTypes.DELETE_APP_SUCCESS:
            let applicationSummary = state.applicationSummary;
            let data = applicationSummary.paginatedDetails;
            let indexOfUpdatedObj = _.findIndex(data, (row) => row.acn === action.payload.acn);
            data.splice(indexOfUpdatedObj, 1);
            let metadata = applicationSummary.current.metadata;
            metadata.pages.totalElements = metadata.pages.totalElements - 1;
            return Object.assign({}, state, { "applicationSummary": applicationSummary });

        case ActionTypes.EDIT_OWNERSHIP_SUCCESS:
            if (state.applicationSummary !== undefined) {
                let indexOfUpdatedObj = _.findIndex(state.applicationSummary.paginatedDetails, (row) => row.acn === action.payload.acn);
                const reqBody = action.payload.reqBody;
                let updateRow = state.applicationSummary.paginatedDetails[indexOfUpdatedObj];
                let reviewer;
                updateRow.acl.forEach((aclObj) => {
                    if (aclObj.accessType === TYPE_OWNER) {
                        aclObj.accessType = TYPE_REVIEWER;
                    } else if (aclObj.accessType === TYPE_REVIEWER && aclObj.userId === reqBody.targetId) {
                        reviewer = aclObj;
                        reviewer.accessType = TYPE_OWNER;
                    }
                });
                if (!reviewer) {
                    updateRow.acl.push({
                        userId: reqBody.targetUserId,
                        userRole: reqBody.producerApplicationRole,
                        accessType: TYPE_OWNER
                    })
                }
                return Object.assign({}, state, { "applicationSummary": state.applicationSummary });
            }
        case ActionTypes.APPLICATION_SUMMARY_NEW_FILTERS_SEARCH:
            return Object.assign({}, state, action.payload);
        case ActionTypes.APPLICATION_SUMMARY_NEW_FILTERS_SEARCH_FAILED:
        case ActionTypes.SET_APLICATION_REST_PROPS:
            return Object.assign({}, state,  action);
        
        case ActionTypes.APPLICATION_DETAIL:
            if (state.applicationSummary && action.payload && action.payload.length) {
                let applicationSummary = state.applicationSummary;
                let data = state.applicationSummary.paginatedDetails;
                let appDetail = action.payload[0];
                let selectedApp = data.find(app => app.acn = appDetail.acn)
                if (selectedApp) {
                    selectedApp.hasAppDetailFetchFailed = false;
                    selectedApp.appDetail = appDetail;
                }

                return Object.assign({}, state, { "applicationSummary": applicationSummary });
            } else {
                return state;
            }

        case ActionTypes.APPLICATIONS_DETAIL_FETCH_FAILED:
            if (state.applicationSummary && action.payload && action.payload.acn) {
                let applicationSummary = state.applicationSummary;
                let data = state.applicationSummary.paginatedDetails;                
                let selectedApp = data.find(app => app.acn = action.payload.acn)
                if (selectedApp) {
                    selectedApp.hasAppDetailFetchFailed = true;
                }

                return Object.assign({}, state, { "applicationSummary": applicationSummary });
            } else {
                return state;
            }
        case ActionTypes.APP_STATUS_DESC_LIST_FETCH_SUCCESS:
            let appStatusDescriptionList = [];
            if (action.payload && action.payload.AppStatusMapping) {
                appStatusDescriptionList = action.payload.AppStatusMapping.map(statusMapping => // take only the require fields
                    ({
                        status: statusMapping['Mapping-Status'] ? statusMapping['Mapping-Status'].trim().toLowerCase() : '',
                        description: statusMapping['Status-ExtraInfo']
                    }));
                appStatusDescriptionList = _.uniqBy(appStatusDescriptionList, 'status');

            }
            return Object.assign({}, state, { "appStatusDescriptionList": appStatusDescriptionList });

        case ActionTypes.APP_STATUS_DESC_LIST_FETCH_FAILURE:
            return Object.assign({}, state, { "appStatusDescriptionList": [] });

     
        case ActionTypes.IND_TRANSFER__INPROGRESS:
            let indTransfer = state.indTransfer;
             indTransfer = {
                success: null,
                error: false,
                loading: true
            };
            return Object.assign({}, state, { "indTransfer": indTransfer });

        case ActionTypes.IND_TRANSFER_SUCCESS:
            if (action.payload && action.payload.statusCode === "SUCCESS") {
                state.indTransfer = {
                    success: true,
                    error: false,
                    loading: false
                }
            }
            return Object.assign({}, state, { "indTransfer": state.indTransfer });
        
        case ActionTypes.IND_TRANSFER_FAILED:
            if (action.payload && action.payload.statusCode !== "SUCCESS") {
                state.indTransfer = {
                    success: false,
                    error: true,
                    loading: false
                }
            }
            return Object.assign({}, state, { "indTransfer": state.indTransfer });

        default:
            return state;
    }
}